import React, { Fragment } from "react";
import Select from "react-select";
const SelectT1 = (props) => {
  const { ...rest } = props;
  return (
    <Fragment>
      <Select styles={styles} {...rest} />
    </Fragment>
  );
};

export default SelectT1;

const styles = {
  control: (styles, state) => {
    return {
      ...styles,
      minWidth: "180px",
      maxWidth: "250px",
    };
  },
  option: (styles, state) => {
    return {
      ...styles,
      // maxWidth: "180px",
    };
  },
};
